import { CommonModule } from '@angular/common';
import {HTTP_INTERCEPTORS, HttpClient, provideHttpClient, withInterceptors} from '@angular/common/http';
import {
    ApplicationConfig,
    EnvironmentProviders,
    Provider,
    importProvidersFrom,
    TransferState,
    PLATFORM_ID, APP_INITIALIZER
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { RouterOutlet, provideRouter } from '@angular/router';
import { CoreModule } from '@core/core.module';
import { dbConfig } from "@core/office/office-chat-repository/office-chat-repository";
import { NgxIndexedDBModule } from "ngx-indexed-db";
import { CLIPBOARD_OPTIONS, ClipboardButtonComponent, MarkdownModule } from 'ngx-markdown';
import { ApiInterceptor } from './interceptors/api.interceptor';
import { routes } from './routes/routes';
import { deviceHashInterceptor } from "./interceptors/device-hash.interceptor";
import {TranslateCompiler, TranslateLoader, TranslateModule} from "@ngx-translate/core";
import {HttpLoaderFactory} from "./modules/i18n/i18n.module";
import {TranslateMessageFormatCompiler} from "ngx-translate-messageformat-compiler";
import { CoreBoot } from "@core/core-boot/core-boot";

const indexedDBProviders = NgxIndexedDBModule.forRoot(dbConfig).providers as Array<Provider | EnvironmentProviders>;

function initializeApp(coreBoot: CoreBoot): () => Promise<void> {
    return () => coreBoot.bootstrap()
}


export const appConfig: ApplicationConfig = {
    providers: [
        importProvidersFrom(
            CommonModule,
            CoreModule,
            RouterOutlet,
            MarkdownModule.forRoot({
                clipboardOptions: {
                    provide: CLIPBOARD_OPTIONS,
                    useValue: {
                        buttonComponent: ClipboardButtonComponent,
                    },
                },
            }),
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: (HttpLoaderFactory),
                    deps: [HttpClient, TransferState, PLATFORM_ID]
                },
                compiler: {
                    provide: TranslateCompiler,
                    useClass: TranslateMessageFormatCompiler
                }
            }),
        ),
        provideHttpClient(
            withInterceptors([deviceHashInterceptor])
        ),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiInterceptor,
            multi: true
        },
        {
            provide: APP_INITIALIZER,
            useFactory: initializeApp,
            multi: true,
            deps: [CoreBoot],
        },
        provideRouter(routes),
        provideAnimations(),
        indexedDBProviders
    ],
};
